import { useTranslation } from "react-i18next";
import { BIOMETRIC_ITEM, CONSENT_ITEMS } from "../legal/consentItems";
import { ConsentRow } from "../legal/ConsentRow";

const ITEMS = [...CONSENT_ITEMS, BIOMETRIC_ITEM];

// موافقات الموظف الجديد قبل أي مسح للوجه — كل مستند بمربع منفصل.
export const JoinConsents = ({ value, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-4 grid gap-3" data-testid="join-consents">
      {ITEMS.map((item) => (
        <ConsentRow
          key={item.id}
          id={item.id}
          checked={Boolean(value[item.id])}
          onChange={(v) => onChange({ ...value, [item.id]: v })}
          label={t(item.label)}
          hint={t(item.hint)}
          to={item.to}
          linkLabel={t(item.link)}
        />
      ))}
    </div>
  );
};
